import cx from 'classnames';
import { motion } from 'framer-motion';

export default function Prose({ className, children, ...props }) {
  return (
    <motion.article
      className={cx(
        'prose prose-neutral leading-normal prose-a:uppercase prose-a:text-primary-500 prose-a:underline-offset-2 focus-visible:prose-a:outline-dashed focus-visible:prose-a:outline-offset-2 focus-visible:prose-a:outline-primary-200 prose-strong:font-medium',
        className
      )}
      {...props}
    >
      {children}
    </motion.article>
  );
}
